// extracted by css-extract-rspack-plugin
export default {"dropdown":"src-components-GlobalHeader-HeaderDropdown-index-module__dropdown--ffIkE"};